import React from "react";
import { motion, cubicBezier } from "framer-motion";

//Data
import { smashData } from "../data/smashData";

//Default transitioncategories
const easing = cubicBezier(0.6, 0.01, -0.05, 0.9);
const transition = { duration: 0.8, ease: easing };


const vegan = (props) => {
  const { setActiveObject, workingHours, getClass } = props;
  const Classic = smashData.filter(item => item.type === "classic");
  const Original = smashData.filter(item => item.type === "original");
  const Jalapeno = smashData.filter(item => item.type === "jalapeno");
  const Blueceese = smashData.filter(item => item.type === "bluecheese");
  const Onionjm = smashData.filter(item => item.type === "onionjam");
  const Smashsides = smashData.filter(item => item.category === "smashsides");
  const Smashdrinks = smashData.filter(item => item.category === "smashdrinks");

  return (
    <>
      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Classic Idzuo Smash</span>
      </motion.h4>
      <ul className="list-menu smash">
        {Classic.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Original Idzuo Smash</span>
      </motion.h4>
      <ul className="list-menu smash">
        {Original.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>


      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Bbq jalapeño</span>
      </motion.h4>
      <ul className="list-menu smash">
        {Jalapeno.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>


      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Blue Cheese</span>
      </motion.h4>
      <ul className="list-menu smash">
        {Blueceese.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>


      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Onion Jam</span>
      </motion.h4>
      <ul className="list-menu smash">
        {Onionjm.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Sides</span>
      </motion.h4>
      <ul className="list-menu smash">
        {Smashsides.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>


      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Drinks</span>
      </motion.h4>
      <ul className="list-menu smash">
        {Smashdrinks.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

    </>
  );
};

export default vegan;
